module.exports = __webpack_public_path__ + "b838b5de4f2f3f18a2b827fb163efe2e.jpg";